<template>
  <div>
    <Modal
      v-model="hunterBrowserSelectModal"
      title="选择需要部署的端口"
      width="1000">
      <div style="text-align: left">
        <RadioGroup v-model="selectType">
          <Radio label="hunterBrowser">常规选择</Radio>
          <!--<Radio label="group" v-if="!single">从分组选择</Radio>-->
        </RadioGroup>
      </div>
      <Divider />
      <div>
        <a v-on:click="allSelect">全选</a>
        <span>已选(<b>{{ selectRow.length }}</b>)：<a v-on:click="emptyHunterBrowser" v-if="selectRow.length">清空 </a> </span>
        <Tag color="primary" closable v-for="(item, index) in selectRow" :key="'port_' + index" @on-close="removeHunterBrowser('remove', item)">{{ item }}</Tag>
      </div>
      <Divider />
      <Form inline :label-width="50" ref="searchHunterBrowserForm" :model="searchHunterBrowserForm">
        <FormItem label="端口">
          <InputNumber :min="1" v-model="searchHunterBrowserForm.port" @on-enter="getHunterBrowsers()" placeholder="过滤端口" style="width: 200px"/>
        </FormItem>
        <FormItem label="公网IP">
          <Input v-model="searchHunterBrowserForm.public_ip" @on-enter="getHunterBrowsers()" placeholder="过滤公网IP" style="width: 200px"/>
        </FormItem>
        <FormItem :label-width="0" class="mob-align-right">
          <Button type="primary" @click="getHunterBrowsers()" style="margin-right: 8px">搜索</Button>
          <Button @click="resetHunterBrowserSearchForm">重置</Button>
        </FormItem>
      </Form>
      <Alert v-if="hunterBrowserError" type="warning" show-icon>获取列表失败</Alert>
      <div v-else>
        <Table
          ref="hunterBrowserTable"
          :loading="hunterBrowserTableLoading"
          :data="hunterBrowser.data"
          size="small"
          @on-sort-change="sortChange"
          :columns="hunterBrowser.columns">
        </Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: left;">
            当前显示 {{ hunterBrowser.data.length }} 条记录，总共 {{ hunterBrowser.count }} 条记录
          </div>
          <div style="float: right;">
            <page :total="hunterBrowser.count" :current="hunterBrowser.page" :page-size="hunterBrowser.size" @on-change="getHunterBrowsers"></page>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="selectHunterBrowserOk" :loading="deploying">确定</Button>
        <Button @click="hunterBrowserSelectModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getHunterBrowser, hunterBrowserBatchDeploy, getHunterBrowserAll } from '@/api/opscenter'

export default {
  name: 'selector',
  data () {
    return {
      // 选择目标服务器
      hunterBrowserError: false,
      hunterBrowserSelectModal: false,
      allData: [],
      single: false,
      selected: [],
      selectType: 'hunterBrowser',
      searchHunterBrowserForm: {
        port: '',
        public_ip: '',
        ordering: ''
      },
      assetParams: {},
      hunterBrowser: {
        data: [],
        columns: [
          {
            title: '选中',
            align: 'center',
            minWidth: 60,
            key: 'checkBox',
            render: (h, params) => {
              let disabled = false
              if (!params.row.port) {
                disabled = true
              }
              let isCheck = false
              if (this.selectRow.indexOf(params.row.port) > -1) {
                isCheck = true
              }
              return h('div', [
                h('Checkbox', {
                  props: {
                    value: isCheck,
                    disabled: disabled
                  },
                  on: {
                    'on-change': (e) => {
                      this.hunterBrowser.data[params.index].checkBox = e
                      if (e) {
                        if (this.single) {
                          this.emptyHunterBrowser()
                        }
                        if (this.selectRow.indexOf(params.row.port) < 0) {
                          this.selectRow.push(params.row.port)
                          this.selectHunterBrowserIds[params.row.port] = params.row.id
                        }
                      } else {
                        this.removeHunterBrowser(null, params.row.port)
                      }
                    }
                  }
                })
              ])
            }
          },
          {
            title: '端口',
            key: 'port',
            align: 'center',
            minWidth: 90
          },
          {
            title: '公网IP',
            key: 'public_ip',
            align: 'center',
            minWidth: 90
          },
          {
            title: '私有IP',
            key: 'private_ip',
            align: 'center',
            minWidth: 100
          },
          {
            title: '用户名',
            key: 'user',
            align: 'center',
            minWidth: 200
          },
          {
            title: '密码',
            key: 'password',
            align: 'center',
            minWidth: 100
          }
        ],
        count: 0,
        page: 1,
        size: 15
      },
      hunterBrowserTableLoading: false,
      selectRow: [],
      selectHunterBrowserIds: {},
      endSelectHunterBrowser: {},
      endSelectHunterBrowserLength: 0,
      id: '',
      deploying: false
    }
  },
  methods: {
    // 打开服务器选择Modal
    openSelectHunterBrowserModal () {
      this.getAllSelectData()
      this.getHunterBrowsers()
      this.hunterBrowserSelectModal = true
    },
    // 获取列表
    getHunterBrowsers (value = 1) {
      this.hunterBrowser.page = value
      this.hunterBrowserTableLoading = true
      this.searchHunterBrowserForm['size'] = this.hunterBrowser.size
      this.searchHunterBrowserForm['page'] = this.hunterBrowser.page
      this.searchHunterBrowserForm['deployed'] = 0
      for (let p in this.assetParams) {
        this.searchHunterBrowserForm[p] = this.assetParams[p]
      }
      this.hunterBrowserError = false
      getHunterBrowser(this.searchHunterBrowserForm).then(res => {
        let result = res.data
        let tableData = result.results
        this.hunterBrowser.count = result.count

        this.hunterBrowser.data = tableData
        this.hunterBrowserTableLoading = false
      }).catch(res => {
        this.hunterBrowserError = true
        this.hunterBrowserTableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取主机列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        }
      })
    },
    // 重置搜索表单
    resetHunterBrowserSearchForm () {
      this.searchHunterBrowserForm = {
        port: '',
        public_ip: '',
        inner_ip: ''
      }
      this.getHunterBrowsers()
    },
    // 移除选中的服务器
    removeHunterBrowser (event, name) {
      if (event) {
        for (let i in this.hunterBrowser.data) {
          if (this.hunterBrowser.data[i].port === name) {
            this.hunterBrowser.data[i].checkBox = false
            break
          }
        }
      }
      const index = this.selectRow.indexOf(name)
      this.selectRow.splice(index, 1)
      this.selectHunterBrowserIds[name] = null
    },
    // 清空选中的服务器
    emptyHunterBrowser () {
      this.selectHunterBrowserIds = {}
      for (let i in this.hunterBrowser.data) {
        this.hunterBrowser.data[i].checkBox = false
      }
      this.selectRow = []
    },
    // 选择服务器完成
    selectHunterBrowserOk () {
      let data = []
      this.deploying = true
      for (let port in this.selectHunterBrowserIds) {
        if (this.selectHunterBrowserIds[port]) {
          data.push(this.selectHunterBrowserIds[port])
        }
      }
      this.startDeploy(data)
    },
    // 排序
    sortChange (params) {
      if (params.order === 'asc') {
        this.searchHunterBrowserForm.ordering = params.key
      } else if (params.order === 'desc') {
        this.searchHunterBrowserForm.ordering = '-' + params.key
      } else {
        this.searchHunterBrowserForm.ordering = ''
      }
      this.getHunterBrowsers()
    },
    startDeploy (ids) {
      let data = {
        ids: ids
      }
      this.deploying = true
      hunterBrowserBatchDeploy(data).then(res => {
        this.deploying = false
        this.hunterBrowserSelectModal = false
        this.$Notice.success({
          title: '操作成功，正在开始部署！'
        })
      }).catch(errO => {
        this.deploying = false
        if (errO.request) {
          this.$Notice.error({
            title: '操作失败！请求状态码:' + errO.request.status,
            desc: errO.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    getAllSelectData () {
      let params = {
        deployed: 0
      }
      getHunterBrowserAll(params).then(res => {
        this.allData = res.data
      })
    },
    allSelect () {
      this.selectRow = []
      for (let i in this.allData) {
        this.selectHunterBrowserIds[this.allData[i].port] = this.allData[i].id
        this.selectRow.push(this.allData[i].port)
      }
    }
  }
}
</script>

<style>
  #rMenu {
    position:absolute;
    visibility:hidden;
    top:0;
    background-color: #555;
    text-align: left;
    padding: 2px;
  }
  #rMenu a{
    padding: 3px 15px 3px 15px;
    cursor: pointer;
    list-style: none outside none;
  }
  .list-group-item {
    position: relative;
    display: block;
    padding: 10px 15px;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid #ddd;
  }
</style>
